// extracted by mini-css-extract-plugin
module.exports = {"container":"OutlinedSection_container__fa6Zn","inputLabel":"OutlinedSection_inputLabel__1AJvr"};